/**
 * Reusable Caliu leaf logo SVG.
 * Uses `currentColor` so it inherits the parent's text color.
 */
export function CaliuLogo({
  size = 20,
  className = '',
  style,
  leafOpacity = 0.3,
}: {
  size?: number
  className?: string
  style?: React.CSSProperties
  leafOpacity?: number
}) {
  const softLeafOpacity = leafOpacity * (4 / 7)

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1154 1154"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path
        d="M587.497 724.631C498.728 613.67 318.374 576.999 251.797 421.652C362.758 421.652 520.92 534.436 587.497 623.205"
        fill="currentColor"
        fillOpacity={leafOpacity}
      />
      <path
        d="M587.497 724.631C498.728 613.67 318.374 576.999 251.797 421.652C362.758 421.652 520.92 534.436 587.497 623.205"
        stroke="currentColor"
        strokeWidth="34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M587.497 724.631C498.728 613.67 318.374 576.998 251.797 421.652C336.918 487.647 512.299 584.606 587.497 655.424"
        fill="currentColor"
        fillOpacity={softLeafOpacity}
      />
      <path
        d="M589.972 887.693C523.395 798.924 390.241 776.732 323.664 643.578C434.626 643.578 545.587 724.544 589.972 791.121"
        fill="currentColor"
        fillOpacity={leafOpacity}
      />
      <path
        d="M589.972 887.693C523.395 798.924 390.241 776.732 323.664 643.578C434.626 643.578 545.587 724.544 589.972 791.121"
        stroke="currentColor"
        strokeWidth="34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M589.972 887.693C523.395 798.924 390.241 776.732 323.664 643.578C543.671 747.154 529.412 779.473 589.972 834.607"
        fill="currentColor"
        fillOpacity={softLeafOpacity}
      />
      <path
        d="M592.188 533.612C680.957 444.843 860.186 377.271 926.763 244.117C815.801 244.117 662.709 287.416 596.132 398.378"
        fill="currentColor"
        fillOpacity={leafOpacity}
      />
      <path
        d="M592.188 533.612C680.957 444.843 860.186 377.271 926.763 244.117C815.801 244.117 662.709 287.416 596.132 398.378"
        stroke="currentColor"
        strokeWidth="34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M592.188 533.612C680.957 444.843 860.186 377.271 926.763 244.117C775.136 308.463 669.147 374.053 592.188 465.783"
        fill="currentColor"
        fillOpacity={softLeafOpacity}
      />
      <path
        d="M590.492 665.771C679.261 599.194 790.223 554.809 856.8 443.848C750.895 500.478 644.905 573.672 590.492 634.034"
        fill="currentColor"
        fillOpacity={softLeafOpacity}
      />
      <path
        d="M590.492 665.771C679.261 599.194 790.223 554.809 856.8 443.848C768.031 443.848 634.877 532.617 590.492 599.194"
        fill="currentColor"
        fillOpacity={leafOpacity}
      />
      <path
        d="M590.492 665.771C679.261 599.194 790.223 554.809 856.8 443.848C768.031 443.848 634.877 532.617 590.492 599.194"
        stroke="currentColor"
        strokeWidth="34"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M592.271 1024.5C592.271 1024.5 580.226 316.565 610.502 165"
        stroke="currentColor"
        strokeWidth="36"
        strokeLinecap="round"
      />
    </svg>
  )
}
